module.exports = __webpack_public_path__ + "media/images/voting_3-83e905756ead9af8fbd9770b90720c29.svg";